<!-- 商品开单 -->
<template>
  <div class="add_product_order" v-loading="loading">
    <div class="container">
      <div class="back">
        <back />
      </div>
      <div class="service_list tabs">
        <el-tabs v-model="categoryId" @tab-click="handleClickTabs">
          <el-tab-pane v-for="(item, index) in category" :key="index" :label="item.categoryName" :name="item.categoryId"></el-tab-pane>
        </el-tabs>
        <el-empty v-if="list.length == 0" description="暂无数据"></el-empty>
        <div class="list">
          <listCard v-for="(item, index) in list" :key="index" :obj="item" @change="changeProduct" />
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
      </div>
    </div>
    <div class="order">
      <!-- <div class="add_member" v-if="!member.memberCode" @click="showMemberList">
        <i class="el-icon-circle-plus"></i>
        <span>选择会员</span>
      </div>
      <div class="member_info" v-if="member.memberCode">
        <i class="close el-icon-error" @click="removeMember"></i>
        <div class="avatar">
          <img :src="member.logoUrl" />
        </div>
        <div class="info">
          <div class="name">
            <div class="text">{{ member.memberName }}</div>
            <div class="balance">余额：{{ member.balance }}元</div>
          </div>
          <div class="cards">会员卡号：{{ member.memberCode }}</div>
        </div>
      </div> -->
      <div class="order_list">
        <div class="item" v-for="(item, index) in order" :key="index">
          <i class="close el-icon-error" @click="removeItem(item)"></i>
          <div class="cell cell1">
            <div class="name">{{ item.productName }}</div>
            <div class=""></div>
          </div>
          <div class="cell">
            <div class="price">￥{{ item.salePrice }}</div>
            <div class="duration">
              <el-input-number size="mini" :min="1" v-model="item.productCount"></el-input-number>
            </div>
          </div>
        </div>
      </div>
      <div class="order_total">
        <div class="cell cell1">
          <div class="name">合计：￥{{ ruleForm.orderAmount }}</div>
          <div class=""></div>
        </div>
      </div>
      <div class="add_order">
        <el-button type="primary" @click="placeOrder(1)" :loading="btnloading">开单</el-button>
        <el-button type="primary" plain @click="placeOrder(2)" :loading="btnloading">挂单</el-button>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :destroy-on-close="true">
      <!-- 选择会员 -->
      <div class="dialog_member" v-if="dialogTitle == '选择会员'">
        <el-input v-model="memberCode" placeholder="请输入会员卡号" clearable @change="searchMember" />
        <div class="dialog_member_list">
          <div class="item" v-for="(item, index) in memberList" :key="index" :class="activeMember == item.id ? 'is_ac' : ''" @click="changeMember(item)">
            <div class="avatar">
              <img :src="item.logoUrl" />
            </div>
            <div class="info">
              <div class="name">
                <div class="text">{{ item.memberName }}</div>
                <div class="balance">余额：{{ item.balance }}元</div>
              </div>
              <div class="num">
                <div class="cards">会员卡号：{{ item.memberCode }}</div>
                <div class="cards">电话号码：{{ item.memberTel }}</div>
                <div class="cards">注册时间：{{ item.createdTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-if="memberList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="pg_input" background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage1" :page-size="pageSize1" :page-sizes="pageSizeArr1" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount1"></el-pagination>
      </div>

      <!-- 选择员工 -->
      <!-- <div class="dialog_employee tabs" v-if="dialogTitle == this.projectName">
        <el-tabs v-model="departmentId" @tab-click="handleClickEmployeeTabs">
          <el-tab-pane v-for="(item, index) in staffDepartmentList" :key="index" :label="item.departmentName" :name="item.departmentId"></el-tab-pane>
        </el-tabs>
        <div class="employee_list" v-loading="employeeloading">
          <div class="employee_list_item" v-for="(item, index) in staffList" :key="index" :class="employeeId == item.employeeId ? 'employee_ac' : ''" @click="changeStaff(item)">
            <div class="icon">
              <i class="el-icon-success" v-if="employeeId == item.employeeId"></i>
              <i class="el-icon-circle-check" v-else></i>
            </div>
            <div class="avatar">
              <img :src="item.avatarUrl || require('@/assets/img/staff.png')" width="60" height="60" />
            </div>
            <div class="info">
              <div class="name overt">{{ item.employeeName }}</div>
              <div class="code overt">员工编号：{{ item.employeeCode }}</div>
              <div class="num">今日服务次数：{{ item.count }}次</div>
            </div>
          </div>
        </div>
        <el-empty v-if="staffList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="pg_input" background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount2"></el-pagination>
      </div> -->

      <!-- 支付 -->
      <div class="dialog_member" v-if="dialogTitle == '支付'">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="ruleForm">
          <el-row type="flex" justify="center">
            <el-form-item label="支付方式">
              <el-select v-model="ruleForm.payType" @change="changeSelect">
                <!-- <el-option v-for="(item, index) in payTypes" :key="index" :label="item" :value="index"></el-option> -->
                <el-option label="微信" value="1"></el-option>
                <el-option label="现金支付" value="2"></el-option>
                <el-option v-if="ruleForm.memberCode" label="会员卡支付" value="3"></el-option>
                <el-option label="收款二维码" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center">
            <el-form-item label="付款金额(元)">
              <el-input v-model="ruleForm.orderAmount" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="会员卡号">
              <el-input v-model="ruleForm.memberCode" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="账户余额(元)">
              <el-input v-model="ruleForm.balance" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 1">
            <el-form-item label="付款码">
              <el-input ref="paycode" v-model="ruleForm.payCode" placeholder="请扫描付款码"></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 4 && qrurl">
            <vue-qr :correctLevel="3" :autoColor="false" colorDark="#1777D9" :text="qrurl" :size="250"></vue-qr>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" v-if="dialogTitle == '选择会员'">
        <el-button @click="cancelMember">取 消</el-button>
        <el-button type="primary" @click="confirmMember">确 定</el-button>
      </span>
      <!-- <span slot="footer" v-if="dialogTitle == this.projectName">
        <el-button  @click="cancelEmployee">取 消</el-button>
        <el-button type="primary"  @click="confirmEmployee">确 定</el-button>
      </span> -->
      <span slot="footer" v-if="dialogTitle == '支付' && ruleForm.payType != 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" :loading="btnloading" @click="confirmPay">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '支付' && ruleForm.payType == 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" :loading="btnloading" @click="confirmPayNew">我已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import listCard from "@/components/listCard.vue"
import VueQr from "vue-qr"
export default {
  components: { listCard, VueQr },
  data() {
    return {
      loading: false,
      employeeloading: false,
      btnloading: false,
      dialogVisible: false,
      dialogTitle: "选择会员",
      productName: "",
      employeeId: "",
      employeeName: "",
      departmentId: "0",
      categoryId: "0",
      memberCode: "",
      activeMember: "",
      category: [],
      list: [],
      memberList: [],
      staffList: [],
      staffDepartmentList: [],
      order: [],
      member: {},
      payTypes: { 1: "微信/支付宝", 2: "现金支付", 3: "会员卡支付" },
      qrurl: "",
      ruleForm: {
        // employeeId: "", // 员工id
        // employeeName: "", // 员工name
        payType: "", // 支付类型:1.线上支付,2.现金支付,3会员卡支付,4收款二维码
        memberCode: "", // 会员卡号
        balance: "", // 会员卡余额
        orderAmount: 0, // 订单金额
        // projectId: "", // 项目id
        // projectName: "", // 项目名字
        // payCode: "", // 付款码
        // storeId: this.$store.state.userInfo.bizId, // 门店id
      },
      // 服务列表分页
      currentPage: 1, // 当前页码
      pageSize: 12, // 每页显示的行数
      pageSizeArr: [12, 24, 60], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      // 会员分页
      currentPage1: 1, // 当前页码
      pageSize1: 5, // 每页显示的行数
      pageSizeArr1: [5, 20, 50], // 每页显示的行数(可选)
      totalItemsCount1: 0, // 总记录数（需要从后端获取）
      // 员工分页
      currentPage2: 1, // 当前页码
      pageSize2: 9, // 每页显示的行数
      pageSizeArr2: [9, 18, 54], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.productCategoryList()
    this.productList()
  },
  methods: {
    totalPrice() {
      let sum = this.order.reduce((total, item) => total + item.productCount * item.salePrice, 0)
      return sum.toFixed(2)
    },
    // 商品分类
    productCategoryList() {
      this.$axios
        .get(this.$api.productCategoryshopProductCategoryList)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              categoryId: e.categoryId.toString(),
            }
          })
          list.unshift({ categoryId: "0", categoryName: "全部" })
          this.category = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 商品列表
    productList() {
      let categoryId = this.categoryId == "0" ? null : this.categoryId
      this.loading = true
      this.$axios
        .post(this.$api.productInfoselectProductList, {
          categoryId,
          storeId: this.$store.state.userInfo.bizId, // 门店id
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.list = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 会员列表
    getMemberList() {
      this.$axios
        .get(this.$api.memberInfopageList, {
          params: {
            memberCode: this.memberCode,
            page: this.currentPage1,
            pageSize: this.pageSize1,
          },
        })
        .then(res => {
          this.memberList = res.result.list
          this.totalItemsCount1 = res.result.totalCount
          this.dialogVisible = true
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 员工列表
    getStaffList() {
      this.employeeloading = true
      this.$axios
        .get(this.$api.employeeInfoselectEmployee, {
          params: {
            parentId: this.departmentId == "0" ? "" : this.departmentId,
            storeId: this.$store.state.userInfo.bizId,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.staffList = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.employeeloading = false
        })
        .catch(err => {
          this.employeeloading = false
          this.$message.error(err.desc)
        })
    },
    // 员工部门
    getStaffDepartmentList() {
      this.$axios
        .get(this.$api.departmentInfoselectParentDepartment)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              departmentId: e.departmentId.toString(),
            }
          })
          list.unshift({ departmentId: "0", departmentName: "全部" })
          this.staffDepartmentList = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    showMemberList() {
      this.dialogTitle = "选择会员"
      this.getMemberList()
    },
    // 搜索会员码
    searchMember(e) {
      this.memberList = []
      this.currentPage1 = 1
      this.getMemberList()
    },
    // 切换分类
    handleClickTabs() {
      this.list = []
      this.currentPage = 1
      this.productList()
    },
    // 切换员工部门
    handleClickEmployeeTabs() {
      this.staffList = []
      this.currentPage2 = 1
      this.getStaffList()
    },
    //   //获取商品支付二维码
    // productQRCode(){
    //     this.$axios
    //     .post(this.$api.product_QRCode_pay_order, {
    //        title: "商品二维码主动支付",
    //       orderCode: this.ruleForm.orderCode,
    //       payAmount: this.ruleForm.orderAmount, // 支付金额
    //     })
    //     .then(res => {
    //        if(res.code==100){
    //       this.qrurl = res.result.qrurl
    //       this.btnloading = false
    //       }else{
    //       this.$message.error(res.desc)
    //       }
    //     })
    //     .catch(err => {
    //       this.$message.error(err.desc)
    //     })
    // },
    // 支付二维码-跳转H5支付
    productQRCode() {
      this.btnloading = false
      const { orderAmount, id, orderCode } = this.ruleForm
      this.qrurl = `https://producth5.ganmiaoedu.com/pagesA/otherPay/otherPay?payPrice=${orderAmount}&sourceId=${id}&sourceNum=${orderCode}&sourceType=${2}`
    },
    changeSelect(e) {
      if (e == 4) {
        this.btnloading = true
        this.productQRCode()
      }
      this.$nextTick(() => {
        if (e == 1) {
          this.$refs.paycode.focus()
        }
      })
    },
    // 删除会员
    removeMember() {
      this.member = []
    },
    // 删除项目
    removeItem(e) {
      // 从数组order删除指定元素
      this.order = this.order.filter(item => item.productId !== e.productId)
      this.ruleForm.orderAmount = this.totalPrice()
    },
    // 切换项目
    changeProduct(e) {
      // 判断this.order中是否存在productId为e.productId的元素
      let index = this.order.findIndex(item => item.productId === e.productId)
      if (index !== -1) {
        // 如果存在，则修改productCount
        this.order[index].productCount += 1
      } else {
        // 如果不存在，则添加新元素
        this.order.push({
          ...e,
          productCount: 1,
        })
      }
      this.ruleForm.orderAmount = this.totalPrice()
      // this.employeeId = ""
      // this.employeeName = ""
      // this.order.push(e)
      // this.projectName = e.projectName
      // // this.dialogTitle = "选择员工"
      // this.dialogTitle = this.projectName
      // this.getStaffDepartmentList()
      // this.getStaffList()
      // this.departmentId = "0"
      // this.dialogVisible = true
    },
    // 切换会员
    changeMember(e) {
      this.activeMember = e.id
      this.member = e
    },
    // 切换员工
    changeStaff(e) {
      this.employeeId = e.employeeId
      this.employeeName = e.employeeName
      this.order = this.order.map(item => {
        return {
          ...item,
          employeeId: e.employeeId,
          employeeName: e.employeeName,
        }
      })
    },
    cancelMember() {
      this.staffDepartmentList = []
      this.dialogVisible = false
    },
    cancelEmployee() {
      this.employeeId = ""
      this.employeeName = ""
      this.order = this.order.map(item => {
        return {
          ...item,
          employeeId: "",
          employeeName: "",
        }
      })
      this.dialogVisible = false
    },
    cancelPay() {
      this.dialogVisible = false
      this.$router.go(-1)
    },
    // 确定会员
    confirmMember() {
      this.dialogVisible = false
    },
    // 确定员工
    confirmEmployee() {
      this.dialogVisible = false
    },
    placeOrder(type) {
      if (this.order.length == 0) {
        this.$message.error("请选择商品")
        // } else if (!this.employeeId) {
        // this.$message.error("请选择员工")
      } else {
        this.btnloading = true
        this.ruleForm = {
          payType: "", // 支付类型:1.线上支付,2.现金支付,3会员卡支付
          // memberCode: this.member.memberCode, // 会员卡号
          // balance: this.member.balance || 0, // 会员余额
          orderAmount: this.totalPrice(), // 订单金额
          payAmount: this.totalPrice(), // 付款金额
          storeId: this.$store.state.userInfo.bizId, // 门店id
          orderProductDto: this.order, // 商品
          cashAmount: 0,
          changeAmount: 0,
          discountAmount: 0,
        }
        this.$axios
          .post(this.$api.cashier_orderproduct_save_order, this.ruleForm)
          .then(res => {
            this.$message.success("下单成功")
            setTimeout(() => {
              if (type == 1) {
                this.ruleForm.id = res.result.orderId
                this.ruleForm.orderCode = res.result.orderCode
                this.dialogTitle = "支付"
                this.dialogVisible = true
              } else {
                this.$router.go(-1)
              }
            }, 1000)
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
          .finally(() => {
            this.btnloading = false
          })
      }
    },
    // 支付
    confirmPay() {
      if (!this.ruleForm.payType) {
        this.$message.error("请选择支付方式")
        return
      }

      let api = ""
      let params = {}
      if (this.ruleForm.payType == 1) {
        // api = this.$api.cashier_orderpayment_code_pay_product_order
        // params = {
        //   userPayCode: this.ruleForm.payCode,
        //   orderCode: this.ruleForm.orderCode,
        //   payAmount: this.ruleForm.orderAmount, // 支付金额
        //   // payAmount: 0.01, // 支付金额
        // }
        api = this.$api.cashier_orderhuifuReversePay
        params = {
          title: "商品二维码主动支付",
          userId: 0,
          payType: Number(this.ruleForm.payType),
          type: Number(this.ruleForm.payType),
          sourceNum: this.ruleForm.orderCode,
          userPayCode: this.ruleForm.payCode,
          sourceType: 2,
          sourceId: this.ruleForm.id,
          payPrice: this.ruleForm.orderAmount, // 支付金额
          // payAmount: 0.01, // 支付金额
        }
      } else {
        api = this.$api.cashier_orderproduct_pay_order
        params = {
          orderId: this.ruleForm.id,
          // memberCode: this.ruleForm.memberCode,
          payType: Number(this.ruleForm.payType),
          type: Number(this.ruleForm.payType),
          payAmount: this.ruleForm.orderAmount, // 支付金额
        }
      }

      this.btnloading = true
      this.$axios
        .post(api, params)
        .then(res => {
          this.$message.success("付款成功")
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
        .finally(() => {
          this.btnloading = false
        })
    },
    //扫码支付
    confirmPayNew() {
      this.btnloading = false
      this.$router.go(-1)
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.list = []
      this.pageSize = e
      this.productList()
    },
    // 换页
    handleCurrentChange(e) {
      this.list = []
      this.currentPage = e
      this.productList()
    },
    // 切换每页显示的条数 - 会员
    handleSizeChange1(e) {
      this.memberList = []
      this.pageSize1 = e
      this.getMemberList()
    },
    // 换页 - 会员
    handleCurrentChange1(e) {
      this.memberList = []
      this.currentPage1 = e
      this.getMemberList()
    },
    // 切换每页显示的条数 - 员工
    handleSizeChange2(e) {
      this.staffList = []
      this.pageSize2 = e
      this.getStaffList()
    },
    // 换页 - 员工
    handleCurrentChange2(e) {
      this.staffList = []
      this.currentPage2 = e
      this.getStaffList()
    },
  },
}
</script>

<style scoped lang="scss">
.add_product_order {
  display: flex;
  justify-content: space-between;
  .container {
    flex: 1;
    max-width: calc(100% - 455px);
    padding-right: 20px;
    box-sizing: border-box;

    .list {
      display: flex;
      flex-wrap: wrap;
      min-height: 504px;
      margin-top: 20px;
    }
  }
  .order {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 455px;
    max-width: 455px;
    height: calc(100vh - 20px - 20px - 70px - 2px);
    padding: 15px;
    border: 1px solid #e2e2e2;
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
    overflow-y: auto;
    .add_member {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 85px;
      color: $themes;
      font-size: 20px;
      border-radius: 6px;
      background: rgba(23, 119, 217, 0.1);
      cursor: pointer;
      &:hover {
        background: rgba(23, 119, 217, 0.3);
      }
      span {
        margin-left: 5px;
      }
    }
    .member_info {
      position: relative;
      display: flex;
      height: 85px;
      color: $themes;
      font-size: 16px;
      padding: 12px;
      border-radius: 6px 6px 6px 6px;
      background: rgba(23, 119, 217, 0.1);
      box-sizing: border-box;
      .avatar {
        img {
          display: block;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
        }
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          display: flex;
          justify-content: space-between;
          .text {
            flex: 1;
            font-weight: bold;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .balance {
            flex: 1;
            font-weight: bold;
            text-align: right;
          }
        }
      }
    }
    .order_list {
      height: calc(100% - 90px - 50px);
      padding: 15px 0;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      .item {
        position: relative;
        color: $themes;
        font-size: 16px;
        padding: 12px;
        border: 1px solid #1777d9;
        margin-bottom: 10px;
        border-radius: 6px 6px 6px 6px;
        background: rgba(23, 119, 217, 0.1);
        overflow: hidden;
        .cell {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            width: 390px;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .price {
            flex: 1;
            font-weight: bold;
          }
          .duration {
            flex: 1;
            text-align: right;
            ::v-deep .el-input-number--mini .el-input-number__increase {
              border-radius: 0 10px 10px 0;
            }
            ::v-deep .el-input-number--mini .el-input-number__decrease {
              border-radius: 10px 0 0 10px;
            }
          }
        }
        .cell1 {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 8px;
        }
      }
    }
    .order_total {
      height: 30px;
      padding: 10px 0;
      color: $themes;
      font-size: 18px;
      font-weight: bold;
      text-align: right;
    }
    .add_order {
      display: flex;
      flex-direction: column;
      height: 90px;
      background-color: #fff;
      .el-button:last-child {
        margin: 10px 0 0;
      }
    }
  }
  .close {
    position: absolute;
    top: -3px;
    right: -3px;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }
  .dialog_member_list {
    padding-top: 20px;

    .item {
      display: flex;
      position: relative;
      color: #707070;
      font-size: 16px;
      padding: 12px;
      margin-bottom: 15px;
      border: 1px solid #f4f6f9;
      border-radius: 6px 6px 6px 6px;
      background: #f4f6f9;
      cursor: pointer;
      .avatar {
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
        }
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          display: flex;
          justify-content: space-between;
          .text {
            flex: 1;
            font-weight: bold;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .balance {
            flex: 1;
            font-weight: bold;
            text-align: right;
          }
        }
        .num {
          display: flex;
          .cards {
            margin-right: 50px;
          }
        }
      }
    }
    .is_ac {
      color: $themes;
      border-color: #1777d9;
      background: rgba(23, 119, 217, 0.1);
    }
  }
  .tabs {
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0;
    }
    ::v-deep .el-tabs__item {
      font-size: 16px;
      padding: 0 15px;
    }
    ::v-deep .el-tabs__item.is-active {
      font-weight: bold;
    }
    ::v-deep .el-tabs__active-bar {
      height: 4px;
      border-radius: 10px;
    }
  }
  .dialog_employee {
    .employee_list {
      display: flex;
      flex-wrap: wrap;
      .employee_list_item {
        display: flex;
        align-items: center;
        width: 295px;
        height: 95px;
        padding: 10px;
        margin-right: 15px;
        margin-bottom: 15px;
        font-size: 14px;
        color: #707070;
        background: #fff;
        box-shadow: 0px 3px 30px 1px rgba(38, 30, 3, 0.04);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        cursor: pointer;
        .icon {
          font-size: 20px;
        }
        .avatar img {
          border-radius: 50%;
          margin: 0 10px;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100%;
          .name {
            color: #0f1c40;
            font-weight: bold;
          }
          .overt {
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .employee_ac {
        color: $themes;
        border-color: $themes;
      }
    }
  }
}
</style>
